import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/mobius/challenges.webp";

function Challengesmobius() {
  return (
    <section
      className="challenges_mobius"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2 style={{ color: "#000" }}>
              <span style={{ color: "#214092" }}>Project </span>
              Challenges
            </h2>
            <p>
              Mobius Risk Group came across multiple challenges during the
              development process.
            </p>
            <p>
              Adapting a complete risk management system to a mobile platform
              posed difficulties in terms of user experience, data conception,
              and data security.
            </p>
            <p>
              Re-designing the functionalities of the traditional ERP system in
              a comprehensible mobile interface required careful development and
              execution.
            </p>
            <p>
              Furthermore, guaranteeing faultless integration with prevailing
              systems and sustaining data integrity were critical considerations
              during the project.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengesmobius;
